<template>
    <order-timeline-box
            :title="__('orders.states.' + OrderState.Cancelled)"
            title-class="text-danger"
            badge-class="bg-danger"
            :message="users[logsByState[OrderState.Cancelled].issuer_uid]"
            :timestamp="logsByState[OrderState.Cancelled].created_at"
            icon="fa-ban"
            complete
    />
</template>

<script>
import OrderTimelineBox from '@components/Orders/Timeline/OrderTimelineBox.vue';
import {OrderState} from '@composables/orderStates';

export default {
    components: {OrderTimelineBox},

    props: {
        users: Object,
    },

    computed: {
        OrderState() {
            return OrderState;
        },

        logsByState(){
            return this.order.logs_by_state;
        },
    },
};
</script>
